import React,{ useState,useEffect } from 'react';
import ReactDOM from 'react-dom';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
// import IconButton from '@material-ui/core/IconButton';
// import DeleteIcon from '@material-ui/icons/Delete';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import ArrowBackOutlinedIcon from '@material-ui/icons/ArrowBackOutlined';
import ArrowForwardOutlinedIcon from '@material-ui/icons/ArrowForwardOutlined';
import CallMadeIcon from '@material-ui/icons/CallMade';
import Hidden from '@material-ui/core/Hidden';
// import Grid from '@material-ui/core/Grid';
import TouchRipple from "@material-ui/core/ButtonBase/TouchRipple";
import Slider from '@material-ui/core/Slider';
// import States from "./model_gl/config";

const useStyles = makeStyles((theme) => ({
   root: {
      width: 170,
   },
   newBtns: {
      borderRadius: "0.1em",
   },

   margin: {
      margin: theme.spacing(2),
      borderRadius: "0.1em",
      textTransform: 'none',
      fontSize: '0.7em'
   },
   extendedIcon: {
      marginRight: theme.spacing(1),
   },
}));


export default function FooterControl(props) {
   const classes = useStyles();
   const [value,setValue] = React.useState(30);
   const [prevDeltaScene,setPrevDeltaScene] = React.useState(0);
   const [zoombarValue,setZoombarValue] = React.useState(0);



   const handleChange = (event,newValue) => {
      setValue(newValue);
   };

   const handleZoomChange = (e,newValue) => {



      if (e) { //console.log(e.target.value);
         window.scene._nav.NavChangeDolly(undefined,e.target.value / 100);

      } else {


         window.scene._nav.NavChangeDolly(undefined,newValue / 100);

         document.getElementById("sliderRange").value = newValue;
      }
      window.hotspot = '';
      window.hideDivs();
      var sliderValues = document.getElementById('sliderRange').value * 100;
      document.getElementById('sliderRange').setAttribute('aria-label','');
      setTimeout(function () {
         document.getElementById('sliderRange').setAttribute('aria-label','%');
      },400)
   };

   const zoombar = {
      height: '40.01px',
      position: 'relative',
      float: 'left',
      marginLeft: '35px',
   }

   const topbtns = {
      position: 'relative',
      border: '1px solid CCCCCC',
      float: 'left',
   }
   const threeButtons = {
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: '500',
      fontSize: '14px',
      lineHeight: '24px',
      letterSpacing: '0.005em',
      backgroundColor: '#FFFFFF',
      height: '40.01px',
      width: '160px',
      margin: '21px 19px 20px 19px',
      border: '2px solid #CCCCCC'
   }
   const mobthreeButtons = {
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: '500',
      fontSize: '16px',
      lineHeight: '24px',
      letterSpacing: '0.005em',
      backgroundColor: '#FFFFFF',
      height: '40.01px',
      width: '123px',
      margin: '5px',
      border: '2px solid #CCCCCC'
   }
   const topLeft = {
      transform: 'rotate(270deg)',
      fontSize: '1.5em'
   }
   const topRight = {
      fontSize: '1.5em'
   }
   const prev = {
      marginRight: '12px',
      fontSize: '1.8em'
   }
   const next = {
      marginLeft: '12px',
      fontSize: '1.8em'
   }
   const topBtnstyle = {
      height: '40.01px',
      width: '62px',
      marginLeft: '8.5px',
      marginRight: '8.5px',
      backgroundColor: '#FFFFFF',
      border: '2px solid #CCCCCC'
   }
   const clearBoth = {
      clear: 'both'
   }
   //only for mob
   const [camData,setCamData] = useState("");
   var animationSwitch = window.animation;
   var animTime = 1;
   const getData = () => {
      fetch('./model_gl/config.json')
         .then(function (response) {
            return response.json();
         })
         .then(function (myJson) {
            setCamData(myJson.positions);
         });
   }
   useEffect(() => {
      getData();
      animationSwitch = window.animation;
      window.position = 'reset';
      return () => {
         return false
      }
   },[]);

   if (animationSwitch == 'on') { animTime = 1000 }
   else { animTime = 1 }

   //new camera function
   const GotoPosInTimeNamedValue = (gotoposname,onComplete,onSample) => {
      var opt = undefined,gp = camData[gotoposname];
      // console.log(gp);
      //    console.log(gp)
      if (gp.fovy && window.scene.fovy != gp.fovy)
         opt = { fovy: gp.fovy };
      if (gp.pos.length > 5) {
         if (!opt)
            opt = {};
         opt.zang = gp.pos[5];
      }
      var animationSwitch = window.animation;
      if (animationSwitch == 'off') { gp.time = 1 }
      else {
         gp.time = animTime;
      }
      window.scene.gotoPosInTime(gp.pos[0],gp.pos[1],gp.pos[2],gp.pos[3],gp.pos[4],gp.time,onComplete,slowInOut,opt);
   }
   //end

   const slowInOut = (x) => {
      var a = 2.1;
      var x2 = 1.0 - x;
      var px = Math.pow(x,a);
      var px2 = Math.pow(x2,a);

      return px / (px + px2);
   }

   const posClicked1 = () => {
      window.scene.animPlayInTime("Screen_grp_timeline_01",0,animTime);
   }


   const onUpdateZoombar = (e) => {
      var s = window.scene;
      var deltaScene = 0;
      // console.log('onUpdateZoombar',zoombarValue)
      deltaScene = zoombarValue;
      setPrevDeltaScene(deltaScene);
      if (prevDeltaScene - deltaScene > 0) {
         // console.log(deltaScene)
         if (s._nav.NavChangeDolly(deltaScene))
            s.clearRefine();
      } else {
         // console.log(-deltaScene)
         if (s._nav.NavChangeDolly(-deltaScene))
            s.clearRefine();
      }
      document.getElementById('sliderRange').value = zoombarValue;
      window.scene.groupApplyState("90_Degree_OFF");
      window.scene.groupApplyState("Height_OFF");
      window.scene.groupApplyState("Swivel_OFF");
      window.scene.groupApplyState("Tilt_OFF");

   }

   const featureCamSet = () => {
      var t = document.getElementById("sliderRange");
      if (window.feature == "webcam") {
         window.setTimeout(() => {
            t.value = window.scene._nav.getZoomFactor()
         },1000);
         window.GotoPosInTimeNamedValue(window.config.closeOut);
         window.scene._nav._navMinDolly = 23
         window.scene._nav._navMaxDolly = 55
         window.scene._nav._panMax = [16,30]
         window.scene._nav._panMin = [-16,-7]
         window.scene._nav.getZoomFactor()
         window.feature = null;
      }
      else if (window.feature == "access") {
         window.setTimeout(() => {
            t.value = window.scene._nav.getZoomFactor()
         },1000);
         window.GotoPosInTimeNamedValue(window.config.front);
         window.scene._nav._navMinDolly = 23
         window.scene._nav._navMaxDolly = 55
         window.scene._nav._panMax = [16,30]
         window.scene._nav._panMin = [-16,-7]
         window.scene._nav.getZoomFactor()
         window.feature = null;
      }
      window.scene.groupApplyState("90_Degree_OFF");
      window.scene.groupApplyState("Height_OFF");
      window.scene.groupApplyState("Swivel_OFF");
      window.scene.groupApplyState("Tilt_OFF");
   }

   const onZoomIn = (e) => {
      if (window.scene._nav.getZoomFactor() > 0)
         handleZoomChange(null,-1 + (parseFloat(document.getElementById("sliderRange").value)))

      featureCamSet();
   }

   const onZoomOut = (e) => {
      if (window.scene._nav.getZoomFactor() < 100)
         handleZoomChange(null,3 + (parseFloat(document.getElementById("sliderRange").value)))

      featureCamSet();
   }


   const onLeft = () => {
      if (window.isipad) {
         window.scene._nav.NavRotation([0,0],[6,0]);
      }
      else {
         window.scene._nav.NavRotation([0,0],[1,0]);
      }
      window.hotspot = '';
      window.hideDivs();
      for (let i = 1; i <= document.getElementsByClassName('hotspots').length; i++) {
         if (document.getElementById('hotspot' + i) !== null) {
            document.getElementById('hotspot' + i).style.display = 'none';
         }
      }
      featureCamSet();

      window.scene.clearRefine();




   }
   const onRight = () => {
      if (window.isipad) {
         window.scene._nav.NavRotation([0,0],[-6,0]);
      }
      else {
         window.scene._nav.NavRotation([0,0],[-1,0]);
      }
      window.hotspot = '';
      window.hideDivs();
      for (let i = 1; i <= document.getElementsByClassName('hotspots').length; i++) {
         if (document.getElementById('hotspot' + i) !== null) {
            document.getElementById('hotspot' + i).style.display = 'none';
         }
      }
      featureCamSet();
      window.scene.clearRefine();
   }
   const rippleRef = React.useRef('null');
   const onRippleStart = (e) => {
      rippleRef.current.start(e);
   };
   const onRippleStop = (e) => {
      rippleRef.current.stop(e);
   };
   const rippleRefs = React.useRef('null');

   const onRippleStarts = (e) => {
      rippleRefs.current.start(e);
   };
   const onRippleStops = (e) => {
      rippleRefs.current.stop(e);
   };
   return (
      <React.Fragment>
         {ReactDOM.createPortal(

            <div id='footerControls' className='footerControlDesk'>
               <Hidden only={['xs','sm','md']}>
                  <div className="threebtns">
                     <div className="zoombarandRotateContainer">

                        <Hidden only={['xs','sm','md']}>
                           <div style={topbtns} >
                              <Button aria-label="Rotate" id="rLeft" tabIndex="2" className={classes.newBtns} style={topBtnstyle} onClick={onLeft} title="left" variant="outlined" size="small" color="primary">
                                 <img alt="Rotate left" src="./img/diagonalLeftArrow.svg" />
                              </Button>
                              <Button aria-label="Rotate" id="rRight" tabIndex="2" className={classes.newBtns} style={topBtnstyle} onClick={onRight} title="right" variant="outlined" size="small" color="primary">
                                 <img alt="Rotate right" src="./img/diagonalRightArrow.svg" />
                              </Button>
                           </div>

                           <div id="zoomSliderContainer" style={zoombar} >
                              <img style={{ height: '100%' }} alt="zoombar" src="./img/ZOOMBAR.svg" />

                              <Button tabIndex="2" style={{ color: "#0076CE" }} type="button" onMouseDown={onRippleStart} onMouseUp={onRippleStop} aria-label="Clickable Zoom Out" role="button" id="zoomIn" onClick={onZoomIn}> <TouchRipple ref={rippleRef} center={false} /></Button>
                              <div id="zoomSlider" aria-hidden="true">
                                 <div className="rangeslider" aria-hidden="true">                                   
                                    <label> <input tabIndex="2" aria-hidden="true" type="range" min="0" max="100" step="1" className="myslider" onChange={handleZoomChange} id="sliderRange" />
                                    </label>
                                 </div>
                              </div>
                              <Button tabIndex="2" style={{ color: "#0076CE" }} type="button" onMouseDown={onRippleStarts} onMouseUp={onRippleStops} id="zoomOut" role="button" aria-label="Clickable Zoom In" onClick={onZoomOut}><TouchRipple ref={rippleRefs} center={false} /></Button>
                           </div>
                        </Hidden>
                     </div>
                     <div style={clearBoth}>
                        <Hidden only='xs'>
                        <Button tabIndex="2" aria-label="Previous view" id="previousView" style={threeButtons} variant="outlined" color="primary" onClick={props.onPrevious} className={classes.margin}>
                              <img alt="Previous view" style={{ height: '20px',width: '24px',paddingRight: '12px' }} src="./img/leftArrow.svg" />{window.finalLangues.previousView}
                           </Button>
                           <Button tabIndex="2" style={threeButtons} variant="outlined" id="resetView" color="primary" onClick={props.onReset} className={classes.margin}>
                           {window.finalLangues.resetView} 
                           </Button>
                           <Button tabIndex="2" aria-label="Next view" style={threeButtons} id="nextView" variant="outlined" color="primary" onClick={props.onNext} expanded={props.expanded} className={classes.margin}>
                              {window.finalLangues.nextView}  <img alt="Next view" style={{ height: '20px',width: '24px',paddingLeft: '12px' }} src="./img/rightArrow.svg" />
                           </Button>
                        </Hidden>

                     </div>
                  </div>


               </Hidden>

            </div>,document.getElementById('footerControlDesk')
         )}
      </React.Fragment>

   );
}
